// extracted by mini-css-extract-plugin
export default {"deleteBtn":"deleteModal_deleteBtn__w+SoW","contentMsg":"deleteModal_contentMsg__LqL0Y","deleteYesNOBtn":"deleteModal_deleteYesNOBtn__orViN"};